import { createContext } from 'react';
import { initalState, initalContext } from './initialState';

export const globalDispatchContext = createContext(initalContext);
export const globalStateContext = createContext(initalState);
